(() => {
  if (window.spPdpLoaded) return;
  window.spPdpLoaded = true;

  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const mobileLayout = window.matchMedia('(max-width: 989px)');

  // Mouse drag-to-swipe on the mobile layout only; touch keeps native scrolling.
  function enableDrag(el, { snapTo } = {}) {
    if (el.dataset.spDrag) return;
    el.dataset.spDrag = '1';
    const syncCursor = () => (el.style.cursor = mobileLayout.matches ? 'grab' : '');
    syncCursor();
    mobileLayout.addEventListener('change', syncCursor);
    let down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('pointerdown', (e) => {
      if (!mobileLayout.matches || e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
      el.style.scrollSnapType = 'none';
      el.style.scrollBehavior = 'auto';
      el.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', (e) => {
      if (!down) return;
      down = false;
      syncCursor();
      el.style.scrollBehavior = '';
      const dx = e.clientX - startX;
      const target = snapTo ? snapTo(startLeft, dx) : null;
      if (target !== null) {
        el.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(() => (el.style.scrollSnapType = ''), 450);
      } else {
        el.style.scrollSnapType = '';
      }
    });
    el.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    el.addEventListener('dragstart', (e) => {
      if (mobileLayout.matches) e.preventDefault();
    });
  }

  function initGallery(root) {
    const track = root.querySelector('[data-sp-track]');
    if (!track) return;
    const slides = qsa('.sp-slide', track);
    const thumbs = qsa('[data-sp-thumb]', root);
    const dots = qsa('[data-sp-dot]', root);
    const counter = root.querySelector('[data-sp-counter]');
    let current = 0;

    const goTo = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };

    const update = (idx) => {
      if (idx === current && counter && counter.dataset.ready) return;
      current = idx;
      if (counter) {
        counter.textContent = `${idx + 1} / ${slides.length}`;
        counter.dataset.ready = '1';
      }
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === idx ? 'true' : 'false'));
      const strip = thumbs[idx]?.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: thumbs[idx].offsetLeft - strip.clientWidth / 2 + thumbs[idx].clientWidth / 2, behavior: 'smooth' });
      }
      dots.forEach((d, n) => d.setAttribute('aria-current', n === idx ? 'true' : 'false'));
      slides.forEach((s, n) => {
        if (n !== idx) s.querySelectorAll('video').forEach((v) => v.pause());
      });
    };

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => update(Math.round(track.scrollLeft / track.clientWidth)));
    }, { passive: true });

    enableDrag(track, {
      snapTo: (startLeft, dx) => {
        const w = track.clientWidth;
        let idx = Math.round(startLeft / w);
        if (dx < -40) idx += 1;
        else if (dx > 40) idx -= 1;
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        return idx * w;
      },
    });

    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.spThumb))));
    qsa('[data-sp-goto]', root).forEach((b) => b.addEventListener('click', () => goTo(Number(b.dataset.spGoto))));
    root.querySelector('[data-sp-prev]')?.addEventListener('click', () => goTo(current - 1));
    root.querySelector('[data-sp-next]')?.addEventListener('click', () => goTo(current + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    const lightbox = root.querySelector('[data-sp-lightbox]');
    if (lightbox) {
      const img = lightbox.querySelector('img');
      qsa('[data-sp-zoom]', root).forEach((btn) => {
        const open = () => {
          img.src = btn.dataset.spZoom;
          img.alt = btn.querySelector('img')?.alt || '';
          lightbox.showModal();
        };
        btn.addEventListener('click', open);
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        });
      });
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox || e.target.closest('[data-sp-close]') || e.target === img) lightbox.close();
      });
    }
    update(0);
  }

  function initCoupons(root) {
    qsa('[data-sp-copy]', root).forEach((btn) => {
      btn.addEventListener('click', async () => {
        const code = btn.dataset.spCopy;
        try {
          await navigator.clipboard.writeText(code);
        } catch (e) {
          const tmp = document.createElement('textarea');
          tmp.value = code;
          document.body.appendChild(tmp);
          tmp.select();
          document.execCommand('copy');
          tmp.remove();
        }
        const label = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel || 'Copied';
        setTimeout(() => (btn.textContent = label), 1800);
      });
    });
  }

  function initQty(root) {
    qsa('[data-sp-qty]', root).forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach((b) =>
        b.addEventListener('click', () => {
          const step = b.name === 'plus' ? 1 : -1;
          const max = Number(input.max) || Infinity;
          input.value = Math.min(max, Math.max(1, (Number(input.value) || 1) + step));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        })
      );
    });
  }

  function istNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(new Date()).reduce((acc, p) => ((acc[p.type] = p.value), acc), {});
    return {
      date: new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day)),
      hour: Number(parts.hour) % 24,
      minute: Number(parts.minute),
    };
  }

  function addWorkingDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;
    }
    return d;
  }

  function initDispatch(root) {
    qsa('[data-sp-dispatch]', root).forEach((el) => {
      const cutoff = Number(el.dataset.cutoff || 18);
      const dispatchDays = Number(el.dataset.dispatchDays || 2);
      const min = Number(el.dataset.min || 3);
      const max = Number(el.dataset.max || 6);
      const now = istNow();
      let start = now.date;
      const beforeCutoff = now.hour < cutoff && start.getDay() !== 0;
      if (!beforeCutoff) start = addWorkingDays(start, 1);
      const dispatchBy = addWorkingDays(start, dispatchDays);
      const from = addWorkingDays(dispatchBy, min);
      const to = addWorkingDays(dispatchBy, max);
      const fmt = (d, withDay) =>
        d.toLocaleDateString('en-IN', withDay ? { weekday: 'short', day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short' });
      const cutoffLabel = new Date(2000, 0, 1, cutoff).toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true }).toUpperCase();

      const lead = el.querySelector('[data-sp-dispatch-lead]');
      const range = el.querySelector('[data-sp-dispatch-range]');
      if (lead) {
        lead.textContent = beforeCutoff
          ? `Order by ${cutoffLabel} today — dispatched by ${fmt(dispatchBy, true)}`
          : `Order now — dispatched by ${fmt(dispatchBy, true)}`;
      }
      if (range) range.textContent = `${fmt(from)}–${fmt(to)}`;
      el.hidden = false;
    });
  }

  function initDialogs(root) {
    qsa('[data-sp-open]', root).forEach((btn) => {
      const dlg = document.getElementById(btn.dataset.spOpen);
      if (!dlg) return;
      btn.addEventListener('click', () => dlg.showModal());
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg || e.target.closest('[data-sp-close]')) dlg.close();
      });
    });
  }

  function initSticky(root) {
    const bar = root.querySelector('[data-sp-sticky]');
    const anchor = root.querySelector('[data-sp-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      bar.inert = !passed;
    });
    io.observe(anchor);
  }

  function initSoldOutReorder(root) {
    if (root.dataset.soldOut !== 'true') return;
    const rail = document.querySelector('[data-sp-rail-section]');
    const mainSection = root.closest('.shopify-section');
    const railSection = rail?.closest('.shopify-section');
    if (mainSection && railSection && mainSection.nextElementSibling !== railSection) {
      mainSection.after(railSection);
    }
  }

  function initRails() {
    qsa('[data-sp-rail-section]').forEach((section) => {
      const rail = section.querySelector('.sp-rail');
      if (!rail || section.dataset.spInit) return;
      section.dataset.spInit = '1';
      enableDrag(rail);
      const step = () => rail.clientWidth * 0.8;
      section.querySelector('[data-sp-rail-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      section.querySelector('[data-sp-rail-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  function init() {
    qsa('[data-sp-main]').forEach((root) => {
      if (root.dataset.spInit) return;
      root.dataset.spInit = '1';
      initGallery(root);
      initCoupons(root);
      initQty(root);
      initDispatch(root);
      initDialogs(root);
      initSticky(root);
      initSoldOutReorder(root);
    });
    initRails();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
